import { useQuery } from '@tanstack/react-query';
import useMembershipPlan from './use-membership-plan';
import { loadMembershipShop } from './data-loaders/shop-loader';

const useMembershipShop = (enabled: boolean = true) => {
  const { data: plan } = useMembershipPlan(enabled);

  return useQuery({
    queryKey: ['membershipShop', plan?.shopId],
    queryFn: () => loadMembershipShop(plan?.shopId ?? ''),
    enabled: enabled && Boolean(plan?.shopId),
  });
};

export default useMembershipShop;
